<template>
    <div class="reminder-alerts-container" v-if="hasEventReminders">
        <div class="reminder-alerts-container-inner w-100">
            <b-alert variant="info" :show="hasEventReminders" class="w-100">
                <b>{{ trans('calendar.you_have_event_reminders') }}</b>
            </b-alert>
        </div>
    </div>
</template>

<script>

    import ReminderController from '@/services/Reminders/ReminderController';

    export default {

        data() {
            return {
                hasEventReminders: false,
                reloadTimer: null
            };
        },

        created() {
            this.loadNotifications();

            const self = this;

            // check every minute
            this.reloadTimer = setInterval(function () {
                self.loadNotifications();
            }, 60000);
        },

        mounted() {
            this.$bus.$on('header.notifications.refresh', this.loadNotifications);
        },

        methods: {

            loadNotifications() {
                ReminderController.getReminders().then(response => {
                    this.hasEventReminders = response.data.length > 0;
                });
            }
        },

        beforeDestroy: function () {
            clearInterval(this.reloadTimer);
        }

    };
</script>



// WEBPACK FOOTER //
// src/components/Alerts/EventReminders.vue